export const EMAIL = "david@servicesprestations.com";

export const HERO_IMG =
    "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=80&w=2000&auto=format&fit=crop";

export const ABOUT_IMG =
    "https://images.unsplash.com/photo-1470075801209-17f9ec0cada6?q=80&w=2000&auto=format&fit=crop";

export const TRADES = [
    {
        code: "43210",
        title: "Electrical Installation",
        icon: "Zap",
        accent: "#F59E0B",
        image:
            "https://images.unsplash.com/photo-1758101755915-462eddc23f57?q=80&w=1600&auto=format&fit=crop",
        tagline:
            "Complete electrical installation — distribution boards, circuits and smart controls, installed, tested and certified.",
        scope: [
            "Full electrical installation for new builds and renovations",
            "Distribution boards, circuits & smart controls",
            "Industrial panel assembly & wiring",
            "Inspection, testing & safety certification",
        ],
    },
    {
        code: "43220",
        title: "Plumbing, Heat & Air-Conditioning Installation",
        icon: "Wind",
        accent: "#06B6D4",
        image:
            "https://images.unsplash.com/photo-1650551182991-b07558247564?q=80&w=1600&auto=format&fit=crop",
        tagline:
            "Water, warmth and climate — pipework, heating systems and air-conditioning engineered as one installation.",
        scope: [
            "Plumbing systems — supply, drainage & sanitary ware",
            "Heating systems & boiler installation",
            "Air-conditioning & ventilation installation",
            "Complex pipework routing & climate management",
        ],
    },
    {
        code: "80200",
        title: "Security Systems Service Activities",
        icon: "ShieldCheck",
        accent: "#10B981",
        image:
            "https://images.unsplash.com/photo-1528312635006-8ea0bc49ec63?q=80&w=1600&auto=format&fit=crop",
        tagline:
            "Protection that never sleeps — surveillance, access control and intrusion detection, installed and maintained.",
        scope: [
            "CCTV surveillance networks",
            "Access control & intercom systems",
            "Intrusion & perimeter detection",
            "System monitoring & maintenance",
        ],
    },
    {
        code: "95220",
        title: "Repair of Household Appliances & Home and Garden Equipment",
        icon: "Wrench",
        accent: "#8B5CF6",
        image:
            "https://images.unsplash.com/photo-1742344334609-a92761c4b1d5?q=80&w=1600&auto=format&fit=crop",
        tagline:
            "When it breaks, we bring it back — precision diagnostics and repair for appliances, home and garden equipment.",
        scope: [
            "Diagnostics & repair of household appliances",
            "Kitchen & laundry equipment restoration",
            "Home & garden equipment servicing",
            "Preventive maintenance & parts replacement",
        ],
    },
];

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
